import { NumInput } from './primitives.jsx';

const TIER_KEYS = ['free', 'pro'];
const TIER_LABEL = { free: 'Free', pro: 'Pro' };

export default function CardProductionSection({ cardProduction, set }) {
  return (
    <div className="rounded-box border border-carbon-100 bg-white overflow-hidden">
      <div className="px-4 py-3 border-b border-carbon-100">
        <p className="label text-carbon-800">Card production · Pulsar's cost</p>
        <p className="caption text-carbon-400 mt-1">
          Production + shipping per new physical card, plus % of new users opting in. Distinct from
          Tier.physicalCardCost (what the user pays).
        </p>
      </div>
      <table className="w-full text-left">
        <thead className="bg-carbon-50">
          <tr className="caption text-carbon-500">
            <th className="px-3 py-2">Tier</th>
            <th className="px-3 py-2 text-right">Cost / new card ($)</th>
            <th className="px-3 py-2 text-right">Physical adoption</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-carbon-100">
          {TIER_KEYS.map((tk) => (
            <tr key={tk}>
              <td className="px-3 py-2 label text-carbon-800">{TIER_LABEL[tk]}</td>
              <td className="px-3 py-2 text-right">
                <NumInput
                  value={cardProduction.costPerNewCard[tk]}
                  step={1}
                  onChange={(v) => set(`cardProduction.costPerNewCard.${tk}`, v)}
                  ariaLabel={`${tk} card cost`}
                />
              </td>
              <td className="px-3 py-2 text-right">
                <NumInput
                  value={cardProduction.physicalAdoption[tk]}
                  pct
                  step={0.01}
                  onChange={(v) => set(`cardProduction.physicalAdoption.${tk}`, v)}
                  ariaLabel={`${tk} adoption`}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
